import EmptyPage from '../../empty-page/emptyPage';

const OrgActivityAnalytics = () => {
    return <EmptyPage />;
};

export default OrgActivityAnalytics;
